import type { GroupLicense as GroupLicenseModel } from '@/adapters/catalogv1.g';

export function extractGroupLicense(model: GroupLicenseModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    groupRef: model.group_ref ?? '',
    licenseRef: model.license_ref ?? '',
    disabledServicePlans: model.disabled_service_plans,
    enabledServicePlans: model.enabled_service_plans,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogGroupLicense = ReturnType<typeof extractGroupLicense>;
